import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import CursorIcon from '../../../components/cursor-icon/cursor-icon.jsx'
import Button from '../../../components/button/button.jsx'
import Heading from '../../../components/heading/heading.jsx'
import ColumnsLayout from '../../../components/columns-layout/columns-layout.jsx'
import Slidetext from '../../../components/slide-text/slide-text.jsx'
import { withPresentation } from '../../../presentation-connectors'

const ResourceSlide = ({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      link: data.teaching_resource.source_url,
      title: data.title || '',
      description: data.description || '',
      descriptionHTML: data.html_description || '',
      image:
        data.teaching_resource.media_sources &&
        data.teaching_resource.media_sources[0] &&
        data.teaching_resource.media_sources[0].original_media_url,
      source: data.teaching_resource.source_type
    }),
    [data]
  )

  return (
    <Slide>
      <ColumnsLayout
        reverse
        image={slideData.image}
        alt={slideData.description}>
        <Heading className={classes.title}>{slideData.title}</Heading>
        {!!slideData.descriptionHTML && (
          <Slidetext
            className={classes.description}
            html={slideData.descriptionHTML}
          />
        )}
        <Button
          className={classes.button}
          icon={<CursorIcon />}
          target="_blank"
          href={slideData.link}>
          View on {slideData.source}
        </Button>
      </ColumnsLayout>
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(ResourceSlide))
